<template>
  <div>
    <div v-for="category in categories" :key="category.id">
      <a data-toggle="collapse" :href="'#category_'+category.id" role="button" aria-expanded="true" :aria-controls="'category_'+category.name" class="form-row m-0 pr-2" :class="{ 'active' : categoryActive.id == category.id }" @click="categoryActiveSet(category)">
        <i v-show="category.categories.length + category.configurations.length > 0" class="material-icons pl-2">arrow_drop_down</i>
        <div v-show="category.categories.length + category.configurations.length == 0" class="arrow-blank">&nbsp;</div>
        {{ category.name }}
        <i v-if="isLoggedIn" class="material-icons mr-0 ml-auto" data-toggle="modal" data-target="#categoryModal" @click.stop="categoryModalSet(true, category, parent)">edit</i>
        <i v-if="isLoggedIn" class="material-icons mr-0" data-toggle="modal" data-target="#categoryModal" @click.stop="categoryModalSet(false, category, parent)">create_new_folder</i>
      </a>
      <div :id="'category_'+category.id" class="collapse hide pl-2">
        <div v-for="configuration in category.configurations" :key="configuration.id">
          <a :href="'#configuration'+configuration.id" class="form-row item m-0" :class="{ 'active' : configurationActive.id == configuration.id }" @click="configurationActiveSet(configuration)">
            <div class="arrow-blank">&nbsp;</div>
            {{ configuration.name }}
          </a>
        </div>
        <Categories :categories="category.categories" :categoryActive="categoryActive" :configurationActive="configurationActive" :parent="category" @categoryModalSet="categoryModalSet" @categoryActiveSet="categoryActiveSet" @configurationActiveSet="configurationActiveSet"/>
      </div>
    </div>
  </div>
</template>

<script>
import Categories from '../components/Categories.vue';
export default {
  name: "Categories",
  props: {
    parent: Object,
    categories: Array,
    categoryActive: Object,
    configurationActive: Object,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn();
    },
  },
  methods: {
    categoryModalSet(editMode, category, parent) {
      this.$emit('categoryModalSet', editMode, category, parent);
    },
    categoryActiveSet(category) {
      this.$emit('categoryActiveSet', category);
    },
    configurationActiveSet(configuration) {
      this.$emit('configurationActiveSet', configuration);
    },
  },
  components: {
    Categories,
  },
}
</script>
